import { useDetailApi } from "../../../swr/useApi";
import { salesService } from "../../api_client";
import type { SaleDetailsDto } from "../../../api";

export function useQuotationDetails(id: number | null) {
  return useDetailApi<SaleDetailsDto>({
    key: id != null && Number.isFinite(id) ? `quotation-details-${id}` : null,
    serviceMethod: async () => await salesService.getSaleDetails(id as number),
  });
}
